/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { CmpTaskDto } from "./cmp-task-dto";
import { UpdateUserModel } from "./update-user-model";

export class ProcessNewUserTaskDto {
    newUserRequestTaskDto: CmpTaskDto;
    updateUserModel: UpdateUserModel;
}
